import styled from "styled-components";

export const Container = styled.footer`
    background-color: ${props=>props.theme.colors.primary};
    color: #FFF;
    display: flex;
    width: 100%;
    justify-content: center;
`;

export const Content = styled.div`
    width: 100%;
    max-width: 960px;
    padding: 15px;
    display: flex;
    justify-content: center;
    font-size: 12px;
    color: #FFF;
`;